export const scopeTypes = [
  { label: "Psicosocial", value: "PSYCHOSOCIAL" },
  { label: "Comunitario", value: "COMMUNITY" },
  { label: "Social", value: "SOCIAL" },
  { label: "Situacional", value: "SITUATIONAL" }
]
